import { provideAppInitializer, inject } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { API_BASE_URL, authInterceptor } from './core/authentication/auth.interceptor';
import { unexpectedErrorInterceptor } from './core/http/unexpected-error.interceptor';
import { ThemeService } from './core/theme/theme.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { spanishPaginatorIntl } from './shared/data-display/paginator-intl';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: MatPaginatorIntl, useFactory: spanishPaginatorIntl },
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withRouterConfig({ canceledNavigationResolution: 'computed' })),
    provideHttpClient(withInterceptors([authInterceptor, unexpectedErrorInterceptor])),
    { provide: API_BASE_URL, useValue: environment.apiUrl },
    provideAppInitializer(() => inject(ThemeService).initialize()),
  ],
};
